/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListPlaygroundsPathParams = NonNullable<operations['listPlaygrounds']['parameters']['path']>;

export type ListPlaygroundsQueryParams = NonNullable<operations['listPlaygrounds']['parameters']['query']>;

export interface Input extends ListPlaygroundsPathParams {
  apiVersion?: string;
  query?: ListPlaygroundsQueryParams;
}

export async function listPlaygrounds(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/playgrounds', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
